import {
  BulkThreatExplainPayload,
  mapSelectedNotes,
} from '../../services/threatExplainService';

// One selected row in the bulk "Add Notes" modal. `domain` is the protected
// asset (brand) name, `threat` is the malicious domain — same shape Home builds
// for both the select-all and per-row selection paths.
export interface SelectedThreatRow {
  domain: string;
  threat: string;
  threatId: number;
  companyId: number;
  domainId: number;
}

export interface NotesBulkExplainInput {
  selectedThreats: SelectedThreatRow[];
  commentText: string;
  selectedNoteIds: number[];
  notesCatalog: any[];
}

// Build the AI campaign-summary payload for already-existing threats selected in
// the Add Notes modal. Unlike the create flow there is no FN enrichment here —
// we lean on the analyst's comment + selected notes for context.
export function buildNotesBulkExplainPayload(
  input: NotesBulkExplainInput,
): BulkThreatExplainPayload | null {
  const { selectedThreats, commentText, selectedNoteIds, notesCatalog } = input;

  const domains = (selectedThreats ?? [])
    .filter(t => !!t?.threat)
    .map(t => ({
      domain: t.threat,
      protected_asset_name: t.domain || null,
    }));

  if (domains.length === 0) return null;

  const brandNames = [
    ...new Set((selectedThreats ?? []).map(t => t.domain).filter(Boolean)),
  ];
  // One shared brand collapses to the top level; mixed brands stay per-domain.
  const protectedAssetName = brandNames.length === 1 ? brandNames[0] : null;

  return {
    domains,
    company_name: null,
    protected_asset_name: protectedAssetName,
    status: null,
    analyst_context: commentText.trim() || null,
    notes: mapSelectedNotes(selectedNoteIds, notesCatalog),
  };
}
